import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { FINANCIALS_QUERY } from "graphql/financials";

// Bearer token is stored by auth flow in localStorage
const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

// Apollo Client instance for financial service
let financialClient = null;

/**
 * Initialize Apollo Client for financial service
 * @returns {ApolloClient} Configured Apollo Client instance
 */
const getFinancialClient = () => {
  if (financialClient) {
    return financialClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  financialClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return financialClient;
};

export async function fetchFinancials(timePeriod = "YTD", highlightsTimePeriod = "YTD", filters = {}) {
  try {
    const client = getFinancialClient();

    const { data } = await client.query({
      query: FINANCIALS_QUERY,
      variables: {
        timePeriod,
        highlightsTimePeriod,
        netSalesFilter: filters,
        salesFilter: filters,
        salesFilterWithSubBrand: filters
      },
      fetchPolicy: "network-only",
    });

    console.log("Financials GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Financials GraphQL error:", error);
    throw error;
  }
}
